// extracted by mini-css-extract-plugin
export default {"button":"_1VVAT dim-button","menu":"_2y5ow","open":"_30cX4","menuItem":"_3foG-","highlighted":"_2MyC-","disabled":"_2BRz6","arrow":"_2EeUm"};